import React from 'react';

const SpinnerInto = () => (
  <div className="spinner-inner-container">
    <div className="spinner-inner" />
  </div>
);

export default SpinnerInto;
